import { useCallback, useState } from "react";
import { HomePanelId } from "./homeLinks";

type CollapseState = Partial<Record<HomePanelId, boolean>>;

const storageKey = (clientId: string) => `home-panels:${clientId}`;

export function readPanelCollapse(clientId: string): CollapseState {
  try {
    const raw = localStorage.getItem(storageKey(clientId));
    return raw ? (JSON.parse(raw) as CollapseState) : {};
  } catch {
    return {};
  }
}

export function writePanelCollapse(clientId: string, state: CollapseState): void {
  try {
    localStorage.setItem(storageKey(clientId), JSON.stringify(state));
  } catch {
    // storage full/unavailable — collapse state is a nicety, not data
  }
}

export function usePanelCollapse(clientId: string): {
  collapsed: CollapseState;
  toggle: (id: HomePanelId) => void;
} {
  const [collapsed, setCollapsed] = useState<CollapseState>(() =>
    readPanelCollapse(clientId)
  );

  const toggle = useCallback(
    (id: HomePanelId) => {
      setCollapsed((prev) => {
        const next = { ...prev, [id]: !prev[id] };
        writePanelCollapse(clientId, next);
        return next;
      });
    },
    [clientId]
  );

  return { collapsed, toggle };
}
